"use strict";
/// <reference path="irep.js"/>

IREP.mobileLanding = (function () {
    var init = function () {

        var type = "";
        var template = "";

        $("#section_emailMe #sendEmail .normalBluePlain").on("click", function () {
            IREP.callApi("MobileLanding", "POST", { platform: type, template: template }).done(function () {
            });
            $("#section_emailMe #sent").show();
            $("#sendEmail").hide();
        });

        $(".mobileWindows").on("click", function () {
            $("#mobileDevices").css("background-image", "url(../content/images/MobileLanding/IREP_MobileAppLandingPage-WindowsPhone.png)");
            $("#sendEmail").show();
            $("#downloadApp").hide();
            $("#section_emailMe #sent").hide();
            type = 'Windows';
            template = 'Windows';
        });
        $(".mobileAndroid").on("click", function () {
            $("#mobileDevices").css("background-image", "url(../content/images/MobileLanding/IREP_MobileAppLandingPage-AndroidPhone.png)");
            if (IREP.options.user.site == "PRC") {
                $("#downloadApp").show();
                $("#sendEmail").hide();
            } else {
                $("#downloadApp").hide();
                $("#sendEmail").show();
            }
            $("#section_emailMe #sent").hide();
            type = 'Android';
            template = 'Android';
        });
        $(".mobileIphone").on("click", function () {
            $("#mobileDevices").css("background-image", "url(../content/images/MobileLanding/IREP_MobileAppLandingPage-Iphone.png)");
            $("#sendEmail").show();
            $("#downloadApp").hide();
            $("#section_emailMe #sent").hide();
            type = 'iOS';
            template = 'iOS';
        });

    }


    return {
        init: init
    };


})();
